import { Utils } from '@/libs/Utils'
import React from 'react'

const NoRecord: React.FC<{ locale: string }> = ({ locale }) => {
    const t = new Utils(locale).Translation
    return (
        <p className="text-center pb-5">{t("blog.search.notfound")}</p>
    )
}

export default NoRecord